import * as api from './api';
import * as MutationTypes from './mutationsTypes';
import { SocialMedia } from './models';

export const socialMediaListRequest = async ({ commit }) => {
  const response = await api.socialMediaListRequest();
  const socialMediaList = SocialMedia.toInstanceList(response.data.results);
  commit(MutationTypes.SOCIAL_MEDIA_LIST, socialMediaList);
};

export const createSocialMediaRequest = async ({ commit }, socialMedia) => {
  const formDataSocialMedia = socialMedia.getFormData();
  const response = await api.createSocialMediaRequest(formDataSocialMedia);
  const newSocialMedia = SocialMedia.toInstance(response.data);
  commit(MutationTypes.CREATE_SOCIAL_MEDIA_SUCCESS, newSocialMedia);
};
export const updateSocialMediaRequest = async ({ commit }, socialMedia) => {
  const socialMediaGuid = socialMedia.guid;
  const formDataSocialMedia = socialMedia.getFormData();
  const response = await api.updateSocialMediaRequest(socialMediaGuid, formDataSocialMedia);
  const updatedSocialMedia = SocialMedia.toInstance(response.data);
  commit(MutationTypes.UPDATE_SOCIAL_MEDIA_SUCCESS, updatedSocialMedia);
};
export const deleteSocialMediaRequest = async ({ commit }, socialMedia) => {
  const serializeSocialMedia = socialMedia.serialize();
  const socialMediaGuid = serializeSocialMedia.guid;
  const deleteSocialMedia = await api.deleteSocialMediaRequest(socialMediaGuid);
  commit(MutationTypes.DELETE_SOCIAL_MEDIA_SUCCESS, deleteSocialMedia);
};
